module.exports = __webpack_public_path__ + "static/img/register-t.def13aab.png";